import EcoSection from 'eco-design/base/eco-section';
import { FC } from 'react';

import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import MinTitle from '../MinTitle';
import styled from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
interface EssentialsProps {
    pageType: string;
}

const Essentials: FC<EssentialsProps> = ({ pageType = 'normal' }) => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.Essentials');
    const title = pageType === 'ac' ? t('ac_title') : t('title');

    let min_title = t('min_title');
    if (pageType === 'ultra') {
        min_title = t('ultra_min_title') || t('min_title');
    } else if (pageType === 'ac') {
        min_title = t('ac_min_title') || t('min_title');
    }

    const subTitle = t.rich(pageType === 'ac' ? 'ac_subTitle' : 'subTitle', {
        sup: (text: string) => <span className="essentials-sup">{text}</span>,
        nowrap: (text: string) => <span className="essentials-nowrap">{text}</span>,
    });
    return (
        <div className={`${styled.Essentials} GtmModuleData-section`} data-section-id="Essentials" data-section-title={t('title')}>
            <div className="essentials-box">
                <div className="essentials-box-info">
                    <MinTitle title={min_title} align="center" />
                    <EcoSection subTitle={subTitle} title={title} className="product-section" subTitleColor="#696C71" />
                </div>
                <div className="img-wrapper">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1747188834709/%E5%88%86%E5%B8%83%E5%BC%8F-%E6%A6%82%E5%BF%B5%E8%A1%A8%E7%8E%B0-0423-1-pc.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1747189597575/%E5%88%86%E5%B8%83%E5%BC%8F-%E6%A6%82%E5%BF%B5%E8%A1%A8%E7%8E%B0-0423-1-h5.png"
                        isOpenLazy
                    />
                </div>
            </div>
        </div>
    );
};

export default Essentials;
